export const FILTER_BY = {
  COMPANY: 'COMPANY',
  PERSON: 'PERSON',
}

export const GRAPH_TYPE = {
  RADIAL_MAP: 'radial',
  LEGAL_BENEFICIAL: 'lbo',
  INVESTEE_MAP: 'investee',
}

export const MAX_INPUT_LENGTH = 255
export const REGEXP_CHARACTERS_BLOCK = [
  '"',
  ':',
  '*',
  '?',
  '"',
  '<',
  '>',
  '|',
  '\\',
  '/',
]

export const CONNECT_MAP_TYPE = {
  [GRAPH_TYPE.RADIAL_MAP]: 'RadialMap',
  [GRAPH_TYPE.LEGAL_BENEFICIAL]: 'LegalBeneficialOwnershipMap',
  [GRAPH_TYPE.INVESTEE_MAP]: 'InvesteeMap',
  INTERCONNECTION_MAP: 'InterconnectionMap',
}
